import { render, staticRenderFns } from "./previous-projects.vue?vue&type=template&id=d2c8d4fe&scoped=true&"
import script from "./previous-projects.vue?vue&type=script&lang=js&"
export * from "./previous-projects.vue?vue&type=script&lang=js&"
import style0 from "./previous-projects.vue?vue&type=style&index=0&id=d2c8d4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c8d4fe",
  null
  
)

export default component.exports